export class ApiError extends Error {
  constructor(readonly status: number, readonly url: string, readonly body: unknown) {
    super(`Request failed with ${status}`);
  }
}

export const isApiError = (error: unknown): error is ApiError => error instanceof ApiError;
